import { getImage } from './indexedDbHelper';

// Cada URL.createObjectURL() retiene su blob en memoria hasta que se revoque o se recargue
// la página. En un kiosco encendido todo el día, con cada pantalla creando URLs nuevas para
// las mismas imágenes, eso son cientos de MB y termina en freeze.
// Acá hay UNA sola URL por imagen, reutilizada, con un tope LRU.

const MAX_URLS = 120;

// Map conserva el orden de inserción, así que sirve de LRU: el primero es el más viejo.
const urls = new Map();

const prune = () => {
  while (urls.size > MAX_URLS) {
    const oldest = urls.keys().next();
    if (oldest.done) return;
    const id = oldest.value;
    URL.revokeObjectURL(urls.get(id));
    urls.delete(id);
  }
};

export const getImageUrl = async (id) => {
  const cached = urls.get(id);
  if (cached) {
    // Refrescar la posición en el LRU
    urls.delete(id);
    urls.set(id, cached);
    return cached;
  }

  try {
    const record = await getImage(id);
    const blob = record && record.data && record.data.blob;
    if (!blob) return null;

    const url = URL.createObjectURL(blob);
    urls.set(id, url);
    prune();
    return url;
  } catch (error) {
    console.log('Error leyendo la imagen', id, error);
    return null;
  }
};

// Se llama cuando se vuelve a descargar una imagen: el id es el mismo pero el blob cambió.
export const revokeImageUrl = (id) => {
  const url = urls.get(id);
  if (url) {
    URL.revokeObjectURL(url);
    urls.delete(id);
  }
};

export const revokeAllImageUrls = () => {
  urls.forEach((url) => URL.revokeObjectURL(url));
  urls.clear();
};

export const countImageUrls = () => urls.size;
